import React, { forwardRef } from "react";
import clsx from "clsx";

interface AppInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  rightIcon?: React.ReactNode;
}

const AppInput = forwardRef<HTMLInputElement, AppInputProps>(
  (
    {
      label,
      error,
      rightIcon,
      className,
      ...props
    },
    ref
  ) => {
    return (
      <div className="flex flex-col gap-2 w-full">
        {label && (
          <label className="text-[11px] uppercase tracking-[0.14em] font-medium text-[rgb(var(--text-muted))]">
            {label}
          </label>
        )}

        <div className="relative">
          <input
            ref={ref}
            {...props}
            autoComplete="off"
            className={clsx(
              `
              w-full h-[46px]
              rounded-md
              border border-[rgb(var(--border-primary))]
              bg-[rgb(var(--surface-2))]
              px-4
              text-[14px]
              text-[rgb(var(--text-primary))]
              placeholder:text-[rgb(var(--text-tertiary))]
              outline-none
              transition-all duration-200

              focus:border-[rgb(var(--color-gold-2))]
              focus:bg-[rgb(var(--surface-1))]
              focus:shadow-[0_0_0_4px_rgba(184,137,58,0.10)]

              hover:border-[rgb(var(--border-secondary))]
              `,
              error &&
                "border-red-500 focus:border-red-500 focus:shadow-red-500/10",
              className
            )}
          />

          {rightIcon && (
            <div className="absolute right-4 top-1/2 -translate-y-1/2 text-[rgb(var(--text-muted))]">
              {rightIcon}
            </div>
          )}
        </div>

        {error && (
          <span className="text-[11px] text-red-500 font-medium">
            {error}
          </span>
        )}
      </div>
    );
  }
);

AppInput.displayName = "AppInput";

export default AppInput;